import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modal-backdrop',
  templateUrl: './modal-backdrop.component.html'
})
export class ModalBackdropComponent implements OnInit {

  @Input() show: boolean;

  constructor() { }

  ngOnInit() {
  }

}
